import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

interface GenericModalState {
  isOpen: boolean;
  component: React.ComponentType<any> | null;
  props: Record<string, any>;
}

const initialState: GenericModalState = {
  isOpen: false,
  component: null,
  props: {},
};

const genericModalSlice = createSlice({
  name: "genericModal",
  initialState,
  reducers: {
    openModal(
      state,
      action: PayloadAction<{
        component: React.ComponentType<any>;
        props?: Record<string, any>;
      }>
    ) {
      state.isOpen = true;
      state.component = action.payload.component;
      state.props = action.payload.props || {};
    },
    closeModal(state) {
      state.isOpen = false;
      state.component = null;
      state.props = {};
    },
  },
});

export const { openModal, closeModal } = genericModalSlice.actions;
export default genericModalSlice.reducer;
